<label [for]="id" class="wrapper">
    <input
        class="input kk-visuallyhidden"
        type="radio"
        [id]="id"
        [formControl]="formControl"
        [name]="control | controlToKeyName"
        [value]="value"
        [checked]="checked"
    />

    <span class="content">
        <ng-content></ng-content>
    </span>
</label>
